module.exports = __webpack_public_path__ + "static/img/smartControl23.b18921f1.jpg";